export default __webpack_public_path__ + "static/media/phage--R-endolysin-sequence.d6a77209.pdf";